
import { supabase } from '@/integrations/supabase/client';

export interface CollectedData {
  balanceSheetData: any[];
  assumptionsData: any;
  hasBalanceSheetData: boolean;
  hasAssumptions: boolean;
}

export async function collectFinancialData(userId: string): Promise<CollectedData> {
  const [balanceSheetData, assumptionsData] = await Promise.all([
    supabase
      .from('balance_sheet_entries')
      .select('*')
      .eq('user_id', userId)
      .order('period_end_date', { ascending: false })
      .limit(36),
    supabase
      .from('financial_assumptions')
      .select('assumptions_data')
      .eq('user_id', userId)
      .maybeSingle()
  ]);

  if (balanceSheetData.error) throw balanceSheetData.error;
  if (assumptionsData.error) throw assumptionsData.error;

  const hasBalanceSheetData = balanceSheetData.data && balanceSheetData.data.length > 0;
  const hasAssumptions = Boolean(
    assumptionsData.data && 
    assumptionsData.data.assumptions_data && 
    Object.keys(assumptionsData.data.assumptions_data as object).length > 0
  );

  return {
    balanceSheetData: balanceSheetData.data || [],
    assumptionsData: assumptionsData.data,
    hasBalanceSheetData,
    hasAssumptions
  };
}
